import { Router } from './Router'
import { AppProvider } from './context/App'

export const App = () => (
  <AppProvider>
    <Router />
  </AppProvider>
)
